import { global_hooks } from 'src/globals';

global_hooks.on('init', init);
function init() {
	const init_button = (btn) => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			window.scrollTo({
				top: 0,
			});
		});
	};

	document.querySelectorAll('.scroll_to_top').forEach(init_button);
}
